import Strings from "../../../Strings";
import { removeNonErrors } from "../../../utils/validators/rpmPatient";

export const MISSED_READINGS_REMINDER_DEFAULT_THRESHOLD = 3; // days
export const MAX_MISSING_READINGS_THRESHOLD = 7; // days

export const readingsSchedulesFieldsEnum = {
  device: {
    fieldId: 'device',
    required: () => { return true },
  },
  vitals: {
    fieldId: 'vitals',
    required: () => { return true },
  },
  label: {
    fieldId: 'label',
    required: () => { return false },
  },
  enrollment_id: {
    fieldId: 'enrollment_id',
    required: () => { return true },
  },
  missed_measurement_reminder: {
    fieldId: 'missed_measurement_reminder',
    getPropertyForDTO: () => 'missed_measurement_reminder',
    toDTO: (schedule) => {
      if (schedule.missed_measurement_reminder_threshold == null) { return undefined; }
      return {
        threshold: schedule.missed_measurement_reminder_threshold,
        message: schedule.message,
      };
    },
    required: () => { return false },
  },
  missed_measurement_reminder_threshold: {
    fieldId: 'missed_measurement_reminder_threshold',
    required: (schedule) => { return schedule.missed_measurement_reminder != null; },
    toDTO: () => { return undefined; },
  },
  message: {
    fieldId: 'message',
    required: (schedule) => { return schedule.missed_measurement_reminder != null; },
    toDTO: () => { return undefined; },
  },
};

export const readingsScheduleToDTO = schedule => {
  return {
      schedule: Object.values(readingsSchedulesFieldsEnum).reduce((acc, field) => {
        const value = schedule[field.fieldId];
          acc[field.getPropertyForDTO ? field.getPropertyForDTO(schedule) : field.fieldId] = field.toDTO ? field.toDTO(schedule) : value;
        return acc;
      }, {})
    };
};

export const readingsSchedulesToDTO = schedules => {
  return Object.values(schedules).map(schedule => {
    return readingsScheduleToDTO(schedule);  
  });
};

export const validateReadingsSchedule = (readingSchedule, patient, label) => {
  const errors = validateDevice(readingSchedule.device, readingSchedule, label)
  .concat(validateVitals(readingSchedule.vitals, readingSchedule, label))
  .concat(validateEnrollment(readingSchedule.enrollment_id, readingSchedule, patient, label))
  .concat(validateTreshold(readingSchedule.missed_measurement_reminder_threshold, readingSchedule, label))
  .concat(validateMessage(readingSchedule.message, readingSchedule, label));
return errors;
};

const validateDevice = (device, schedule, label) => {
  const ret = [];
  if (!device) {
    ret.push({ property: 'device', propertyName: `${Strings.patient_medications.device} for ${label}`, errors: [], missing: readingsSchedulesFieldsEnum.device.required(schedule) });
  }
  return removeNonErrors(ret);
};

const validateVitals = (vitals, schedule, label) => {
  const ret = [];
  if (!vitals || !vitals.length) {
    ret.push({ property: 'vitals', propertyName: `${Strings.vitals} for ${label}`, errors: [], missing: readingsSchedulesFieldsEnum.vitals.required(schedule) });
  }
  return removeNonErrors(ret);
};

const validateEnrollment = (enrollmentId, schedule, patient, label) => {
  if (!patient?.patientEnrollment?.enrollments) {
    return [];
  }
  const ret = { property: 'enrollment_id', propertyName: `${Strings.enrollment} for ${label}`, errors: [] };
  if (!enrollmentId) {
    ret.missing = readingsSchedulesFieldsEnum.enrollment_id.required(schedule);
  } else if (!Object.keys(patient.patientEnrollment.enrollments)?.some(e => e === enrollmentId)) {
    ret.errors.push("Wrong enrollment Id");
  }
  return removeNonErrors([ret]);
}

const validateTreshold = (threshold, schedule, label) => {
  const ret = { property: 'missed_measurement_reminder_threshold', propertyName: `${Strings.capPatient.missedReadingsTreshold} for ${label}`, errors: []};
  if (isNaN(threshold)) {
    ret.missing = readingsSchedulesFieldsEnum.missed_measurement_reminder_threshold.required(schedule);
  } else if (threshold > MAX_MISSING_READINGS_THRESHOLD) {
    ret.errors.push(Strings.formatString(Strings.valueMustBeLessThan, MAX_MISSING_READINGS_THRESHOLD));
  } else if (!Number.isInteger(threshold) || threshold <= 0) {
    ret.errors.push(Strings.formatString(Strings.capPatient.incorrectFieldValue, threshold));
  }
  return removeNonErrors([ret]);
}

const validateMessage = (message, schedule, label) => {
  const ret = { property: 'message', propertyName: `${Strings.capPatient.missedReadingsMessage} for ${label}`, errors: []};
  if (!message) {
    ret.missing = readingsSchedulesFieldsEnum.message.required(schedule);
  }
  return removeNonErrors([ret]);
}
